import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/App";
import { SharedHeader } from "@/components/SharedHeader";

const AboutPage = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <div className="min-h-screen bg-[#050505]" data-testid="about-page">
      <SharedHeader 
        activeSection={null}
        setActiveSection={() => {}}
        mobileMenuOpen={mobileMenuOpen}
        setMobileMenuOpen={setMobileMenuOpen}
      />

      <main className="pt-24 pb-16 px-4">
        <div className="max-w-4xl mx-auto">
          <h1 className="font-bebas text-4xl md:text-5xl tracking-wider text-white mb-8">
            ABOUT BOARD2BOSTON™
          </h1>
          
          <div className="prose prose-invert max-w-none">
            <div className="text-[#A1A1AA] font-ubuntu space-y-6">
              <h2 className="font-bebas text-2xl text-[#7a6200] mt-8">THE SPARK OF AN IDEA</h2>
              <p>Board2Boston™ began with a simple lunch conversation—one that revealed how powerful everyday dialogue can be in shaping meaningful solutions.</p>
              <p>Keith Bolden, founder of 713 Consulting & Development, was dining with his adult niece, CéYon Fontenette, at a Houston Galleria restaurant after she kindly offered transportation. During the meal, she shared a familiar frustration: despite loving Spades, finding reliable players in her community had become difficult.</p>
              <p>For her, the game represented more than entertainment—it was tradition, connection, and friendly rivalry. Yet adult schedules and limited access to organized play made participation increasingly rare.</p>
              <p>Hearing this, he immediately recognized a broader issue. Many enthusiasts nationwide share the same challenge: a passion for classic games paired with limited opportunities to gather.</p>
              <p>At that table, a decision was made to create a solution. Drawing on professional experience in technology consulting, he committed to building a platform that addressed this widespread need.</p>
              
              <h2 className="font-bebas text-2xl text-[#7a6200] mt-8">FROM IDEA TO REALITY</h2>
              <p>Within days, the concept evolved into a detailed blueprint for a gaming coordination platform. The vision addressed multiple challenges at once: connecting players, empowering hosts, partnering with venues, and enhancing safety through identity verification and transparent event listings.</p>
              <p>The result is Board2Boston™—a platform that helps players find games, while enabling organizers to build thriving local communities.</p>
              
              <h2 className="font-bebas text-2xl text-[#7a6200] mt-8">WHY BOARD2BOSTON™ MATTERS</h2>
              <p>What began as one person's frustration grew into a community-focused platform. It reflects a commitment to solving practical problems while restoring access to shared experiences.</p>
              <p>Gaming fosters relationships, strengthens neighborhoods, and promotes strategic thinking. When access disappears, people lose more than recreation—they lose opportunities for connection and growth.</p>
              <p>Board2Boston™ ensures players can easily find opportunities, whether searching for Spades tournaments, Whist meetups, Backgammon matches, or Checkers lessons.</p>
              
              <h2 className="font-bebas text-2xl text-[#7a6200] mt-8">THE TEAM BEHIND BOARD2BOSTON™</h2>
              <p>713 Consulting & Development brings expertise in software development, technology consulting, and business solutions to the platform. Based in Houston, the team focuses on building tools that strengthen communities and solve real-world challenges.</p>
              <p>The development philosophy is human-centered—listening to users, understanding obstacles, and transforming feedback into functional solutions.</p>
              
              <h2 className="font-bebas text-2xl text-[#7a6200] mt-8">OUR COMMITMENT TO YOU</h2>
              <p>Board2Boston™ is rooted in the belief that progress begins with listening and action. While the original challenge inspired this platform, the commitment extends to every member of the community.</p>
              <p>We prioritize safety through verification, support hosts who create inclusive events, partner with quality venues, and continuously improve the platform using user feedback.</p>
              
              <h2 className="font-bebas text-2xl text-[#7a6200] mt-8">LOOKING FORWARD</h2>
              <p>From that first conversation at the Galleria to the growing network of players today, Board2Boston™ reflects what happens when innovation meets community needs.</p>
              <p>We invite you to join the journey. Whether you're seeking your next Spades match, organizing a Whist tournament, or building consistent Backgammon competition, Board2Boston™ is ready to support you.</p>
              <p className="text-white text-lg font-medium mt-8">Thank you for being part of the community.</p>
            </div>
          </div>
        </div>
      </main>

      <footer className="border-t border-white/10 bg-[#0A0A0A] py-8">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <p className="text-[#52525B] font-ubuntu text-sm">
            © 2026 All Rights Reserved | Board2Boston™ | 713 Consulting and Development
          </p>
          <p className="text-[#52525B] font-ubuntu text-xs mt-2">
            1942 W. Gray St., Box #1259 | Houston, TX 77019 | United States
          </p>
        </div>
      </footer>
    </div>
  );
};

export default AboutPage;
